import BushmasterImg from '../media/images/bushmaster.jpg';
import AbramsImg from '../media/images/m1a1.webp';
import AbramsImgWpnKill from '../media/images/m1a1-wpnkill.webp';
import AbramsImgMobKill from '../media/images/m1a1-mobkill.webp';
import AbramsImgCommsKill from '../media/images/m1a1-commskill.webp';
import AbramsImgTotalKill from '../media/images/m1a1-totalkill.webp';


import BoxerImg from '../media/images/boxer.webp';
import BoxerImgWpnKill from '../media/images/boxer-wpnkill.webp';
import BoxerImgMobKill from '../media/images/boxer-mobkill.webp';
import BoxerImgCommsKill from '../media/images/boxer-commskill.webp'
import BoxerImgTotalKill from '../media/images/boxer-totalkill.webp'

import Ammunition from '../components/Ammunition';

export const VehicleInformation = () => {
    const platforms = {
        Bushmaster: {
            enable: false,
            image: BushmasterImg,
            variants: {
                Command: {
                    image: BushmasterImg,
                    enable: true,
                    description: "Bushmaster PMV Command",
                    ammunition: {
                        type: "5.56mm",
                        capacity: 2000,
                    }
                },
                Troop: {
                    enable: true,
                    image: BushmasterImg,
                    description: "Bushmaster PMV Troop",
                    Ammunition: {
                        type: "5.56mm",
                        capacity: 2000,
                    }

                }
            }
        },
        Abrams: {
            enable: true,
            image: AbramsImg,
            variants: {
                M1A1: {
                    enable: true,
                    image: AbramsImg,
                    imageWpnKill: AbramsImgWpnKill,
                    imageMobKill: AbramsImgMobKill,
                    imageCommsKill: AbramsImgCommsKill,
                    imageTotalKill: AbramsImgTotalKill,
                    description: "Abrams M1A1 Main Battle Tank (MBT)",
                    ammunition: {
                        type: "120mm",
                        capacity: 42,
                    }
                },
                ArmoredBridgeLayer: {
                    enable: false,
                    image: AbramsImg,
                    imageWpnKill: AbramsImgWpnKill,
                    imageMobKill: BoxerImgMobKill,
                    imageCommsKill: AbramsImgCommsKill,
                    imageTotalKill: AbramsImgTotalKill,
                    description: "Abrams Armored Bridge Layer (ABV)",
                    ammunition: {
                        type: "120mm",
                        capacity: 42,
                    }
                },
                Recovery: {
                    enable: true,
                    image: AbramsImg,
                    imageWpnKill: AbramsImgWpnKill,
                    imageMobKill: AbramsImgMobKill,
                    imageCommsKill: AbramsImgCommsKill,
                    imageTotalKill: AbramsImgTotalKill,
                    description: "Abrams Recovery Vehicle (ARV)",
                    ammunition: {
                        type: "120mm",
                        capacity: 42,
                    }
                },
                Engineer: {
                    enable: true,
                    image: AbramsImg,
                    imageWpnKill: AbramsImgWpnKill,
                    imageMobKill: AbramsImgMobKill,
                    imageCommsKill: AbramsImgCommsKill,
                    imageTotalKill: AbramsImgTotalKill,
                    description: "Abrams Engineer Vehicle (AEV)",
                    ammunition: {
                        type: "120mm",
                        capacity: 42,
                    }
                }
            }
        },
        Boxer: {
            enable: true,
            image: BoxerImg,
            variants: {
                Command: {
                    enable: true,
                    image: BoxerImg,
                    imageWpnKill: BoxerImgWpnKill,
                    imageMobKill: BoxerImgMobKill,
                    imageCommsKill: BoxerImgCommsKill,
                    imageTotalKill: BoxerImgTotalKill,
                    description: "Boxer Command Vehicle",
                    ammunition: {
                        type: "5.56mm",
                        capacity: 2000,
                    },
                    features: {
                        Reactive_Armor: false,
                        EW_Emitter: false
                    }
                }
            }
        }
    }

    const getById = (id) => {
        if (!platforms[id]) throw new Error(`No platform with that ID exists: ${id}`);
        return platforms[id];
    }

    const getVariant = (variantId, id) => {
        let platform = getById(id);
        if (!platform.variants[variantId]) throw new Error(`No variant with that ID exists: ${variantId}`);
        return platform.variants[variantId];
    }

    return {
        platforms,
        getPlatformsList: () => Object.keys(platforms),
        getVariantsList: (id) => Object.keys(getById(id).variants),
        getById,
        getVariant
    };
}